/* NLC — "Complete your look & save", a segment of the ATC card.

   Injected rather than edited into main-product.liquid (46KB) or
   buy-buttons.liquid (19KB), since the theme file API only does full-file
   replacement and neither is worth rewriting for one block.

   DISPLAY ONLY. The tiers below are not wired to any Shopify discount yet.

   Placement + styling: nlc-custom.css builds ONE card out of three blocks
   (buy_buttons, icon-with-text, shipping) sharing background #f5f2ee and
   side shadows with margins zeroed. This block copies that so it reads as
   part of the same card, and draws its divider the way the trust block does.

   Vertical rhythm: the icon is taller than nothing else in the row, so on
   desktop it sets the row height and creates slack under the text. Bottom
   padding is kept small because the icon, not the padding, makes the gap. */
(function () {
  var TIER_1_QTY = 3;
  var TIER_1_PCT = 5;
  var TIER_2_QTY = 4;
  var TIER_2_PCT = 10;

  function injectStyles() {
    if (document.getElementById('nlc-bundle-promo-css')) return;
    var css =
      '.nlc-promo{position:relative;background:#f5f2ee;' +
      'box-shadow:-1px 0 0 #e2ddd8,1px 0 0 #e2ddd8;' +
      'border:none;border-radius:0;margin:0;padding:0 20px 8px;' +
      'display:block;text-align:left;}' +
      '.nlc-promo::before{content:"";display:block;height:1px;' +
      'background:#e2ddd8;margin-bottom:14px;}' +
      '.nlc-promo + .product__block--icon-with-text{margin-top:0 !important;}' +
      '.nlc-promo__inner{display:flex;align-items:center;flex-wrap:wrap;gap:1.4rem;}' +
      '.nlc-promo__icon{flex:0 0 4rem;width:4rem;height:4rem;border-radius:50%;' +
      'background:#e8e0d7;display:flex;align-items:center;justify-content:center;color:#46595d;}' +
      '.nlc-promo__icon svg{width:2.1rem;height:2.1rem;}' +
      '.nlc-promo__body{flex:1 1 20rem;min-width:0;}' +
      '.nlc-promo__title{margin:0 !important;font-size:1.25rem;font-weight:700;' +
      'letter-spacing:.06em;text-transform:uppercase;color:#c0674a;line-height:1.3;}' +
      '.nlc-promo__sub{margin:.2rem 0 0 !important;font-size:1.3rem;color:#7a8e90;line-height:1.4;}' +
      '.nlc-promo__tiers{margin:.25rem 0 0 !important;font-size:1.35rem;font-weight:700;' +
      'color:#46595d;line-height:1.4;}' +
      '.nlc-promo__dot{margin:0 .5rem;color:#b9b2aa;}' +
      '.nlc-promo__cta{flex:0 0 auto;display:inline-flex;align-items:center;gap:.6rem;' +
      'padding:.85rem 1.5rem;border:1px solid #c0674a;border-radius:9999px;background:none;' +
      'color:#c0674a;font-family:inherit;font-size:1.25rem;font-weight:500;cursor:pointer;' +
      'text-transform:none;letter-spacing:0;line-height:1;white-space:nowrap;' +
      'transition:background .15s ease,color .15s ease;}' +
      '.nlc-promo__cta:hover{background:#c0674a;color:#fff;}' +
      '.nlc-promo__cta svg{width:1.25rem;height:1.25rem;}' +
      '@media (min-width:750px){.nlc-promo__cta{margin-left:auto;}}' +
      '@media (max-width:749px){' +
      '.nlc-promo{padding-bottom:14px;}' +
      '.nlc-promo__inner{flex-direction:column;align-items:center;text-align:center;gap:0;}' +
      '.nlc-promo__icon{display:none;}' +
      '.nlc-promo__body{flex:0 0 auto;width:100%;}' +
      '.nlc-promo__tiers{margin-top:.45rem !important;}' +
      '.nlc-promo__cta{margin-top:1.2rem;}}';
    var s = document.createElement('style');
    s.id = 'nlc-bundle-promo-css';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'nlc-promo';
    wrap.innerHTML =
      '<div class="nlc-promo__inner">' +
        '<div class="nlc-promo__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 32 32" fill="none">' +
            '<rect x="3" y="9" width="16" height="16" rx="3" transform="rotate(-6 3 9)" stroke="currentColor" stroke-width="1.6"/>' +
            '<rect x="13" y="7" width="16" height="16" rx="3" transform="rotate(6 13 7)" stroke="currentColor" stroke-width="1.6"/>' +
          '</svg>' +
        '</div>' +
        '<div class="nlc-promo__body">' +
          '<p class="nlc-promo__title">Complete your look &amp; save</p>' +
          '<p class="nlc-promo__sub">Mix &amp; match cushions across our range</p>' +
          '<p class="nlc-promo__tiers">' + TIER_1_QTY + ' cushions = ' + TIER_1_PCT + '% off' +
            '<span class="nlc-promo__dot">\u2022</span>' +
            TIER_2_QTY + '+ cushions = ' + TIER_2_PCT + '% off</p>' +
        '</div>' +
        '<button class="nlc-promo__cta" type="button" data-nlc-promo-cta>' +
          '<span>Explore matching cushions</span>' +
          '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>';
    return wrap;
  }

  function mount() {
    if (document.querySelector('.nlc-promo')) return;
    // Only on products that render the buying guide — it excludes throw
    // rugs, inserts, outdoor and bundles, and the CTA needs it.
    if (!document.getElementById('nlcCompleteLook')) return;

    // Sit between the buy buttons and the trust icons, inside the ATC card.
    var buy = document.querySelector('.product__block--buy_buttons');
    if (buy && buy.parentNode) {
      injectStyles();
      buy.insertAdjacentElement('afterend', build());
      return;
    }

    var form = document.querySelector('.main-product-form');
    if (!form) return;
    var anchor = form.closest('.product__block') || form;
    if (!anchor.parentNode) return;

    injectStyles();
    anchor.insertAdjacentElement('afterend', build());
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('[data-nlc-promo-cta]')) return;

    var target = document.getElementById('nlcCompleteLook');
    if (!target) return;

    var row = document.querySelector('.nlc-sofa-row[data-sofa="3seater"]');
    if (row) row.click();

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - 90,
      behavior: 'smooth'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  // The product form re-renders on variant change; re-mount if we lose it.
  setTimeout(mount, 600);
  setTimeout(mount, 1600);
})();
